import * as React from "react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "components/bootstrap";
import AddEvidenceModal from "./shared/AddEvidenceModal";
const CoreMessageActions = ({ id, index }) => {
  const { t } = useTranslation("enterprise_security_investigations");
  const addEvidenceModalRef = useRef(null);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { bsSize: "sm", onClick: () => {
    var _a;
    return (_a = addEvidenceModalRef.current) == null ? void 0 : _a.toggle();
  } }, t("core_actions.add_to_investigation_button")), /* @__PURE__ */ React.createElement(AddEvidenceModal, { index, ids: [id], type: "logs", ref: addEvidenceModalRef }));
};
export default CoreMessageActions;
